<template>
  <v-btn
    class="expansion-button py-3 white--text"
    color="#516188"
    elevation="0"
    x-small
    @click="$emit('click')"
  >
    <v-icon>{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'ExpansionButton',
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    icon() {
      return this.collapsed ? 'chevron_right' : 'chevron_left';
    },
  },
};
</script>

<style scoped>
.expansion-button {
  border-top-left-radius: 8px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 8px !important;
}
</style>
